/**
 * tabbar 选择的策略，更详细的介绍见 tabbar.md 文件
 * 0: 'NO_TABBAR' `无 tabbar`
 * 1: 'NATIVE_TABBAR'  `完全原生 tabbar`
 * 2: 'CUSTOM_TABBAR_WITH_CACHE' `有缓存自定义 tabbar`
 * 3: 'CUSTOM_TABBAR_WITHOUT_CACHE' `无缓存自定义 tabbar`
 *
 * 温馨提示：本文件的任何代码更改了之后，都需要重新运行，否则 pages.json 不会更新导致错误
 */
export const TABBAR_MAP = {
  NO_TABBAR: 0,
  NATIVE_TABBAR: 1,
  CUSTOM_TABBAR_WITH_CACHE: 2,
  CUSTOM_TABBAR_WITHOUT_CACHE: 3,
}
// TODO：通过这里切换使用tabbar的策略
export const selectedTabbarStrategy = TABBAR_MAP.CUSTOM_TABBAR_WITH_CACHE

// selectedTabbarStrategy==NATIVE_TABBAR(1) 时，需要填 iconPath 和 selectedIconPath
// selectedTabbarStrategy==CUSTOM_TABBAR(2,3) 时，需要填 icon 和 iconType
// selectedTabbarStrategy==NO_TABBAR(0) 时，tabbarList 不生效
export const tabbarList = [
  {
    iconPath: 'static/tabbar/personal.png',
    selectedIconPath: 'static/tabbar/personalHL.png',
    pagePath: 'pages/index/index',
    text: '首页',
    icon: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n'
      + '<path d="M10.75 3.125C15.2373 3.125 18.875 6.76269 18.875 11.25C18.875 15.7373 15.2373 19.375 10.75 19.375C6.26269 19.375 2.625 15.7373 2.625 11.25C2.625 6.76269 6.26269 3.125 10.75 3.125Z" stroke="black" stroke-width="1.25"/>\n'
      + '<path d="M7.5 7.625C7.5 7.27982 7.77982 7 8.125 7C8.47018 7 8.75 7.27982 8.75 7.625V9.875C8.75 10.2202 8.47018 10.5 8.125 10.5C7.77982 10.5 7.5 10.2202 7.5 9.875V7.625Z" fill="black"/>\n'
      + '<path d="M13 7.625C13 7.27982 13.2798 7 13.625 7C13.9702 7 14.25 7.27982 14.25 7.625V9.875C14.25 10.2202 13.9702 10.5 13.625 10.5C13.2798 10.5 13 10.2202 13 9.875V7.625Z" fill="black"/>\n'
      + '</svg>',
    // 选用 UI  框架自带的 icon时，iconType 为 uiLib
    iconType: 'iconfont',
  },
  {
    iconPath: 'static/tabbar/home.png',
    selectedIconPath: 'static/tabbar/homeHL.png',
    pagePath: 'pages/mine/index',
    text: '我的',
    icon: '',
    iconType: 'iconfont',
  },
]

// NATIVE_TABBAR(1) 和 CUSTOM_TABBAR_WITH_CACHE(2) 时，需要tabbar缓存
export const cacheTabbarEnable = selectedTabbarStrategy === TABBAR_MAP.NATIVE_TABBAR
  || selectedTabbarStrategy === TABBAR_MAP.CUSTOM_TABBAR_WITH_CACHE

const _tabbar = {
  color: '#999999',
  selectedColor: '#000000',
  backgroundColor: '#F8F8F8',
  borderStyle: 'black',
  height: '50px',
  fontSize: '10px',
  iconWidth: '24px',
  spacing: '3px',
  list: tabbarList,
}

// 0和1 需要显示底部的tabbar的各种配置，以利用缓存
export const tabBar = cacheTabbarEnable ? _tabbar : undefined
